// Реклама на страницы трендов /go/<id>: при заходе запоминаем тренд и метки utm,
// заход сразу отдаём серверу (раз за сессию), а метку — когда человек вошёл (refreshMe в actions.ts).
// Метка лежит в localStorage: вход через Яндекс или VK уводит со страницы и возвращает на /?auth=…, без меток в адресе.
// Сервер — server/src/ads.ts, сводка — в админке у тренда, кнопка «Реклама».
// VK Реклама сама дописывает к ссылке метку перехода rb_clickid: с ней сервер сообщит VK об оплате (server/src/vkads.ts).
import { api, MOCK } from './api';

const KEY = 'dubl.ad';

export interface AdTag {
  trendId: string;
  source: string | null;
  medium: string | null;
  campaign: string | null;
  content: string | null;
  clickId?: string | null; // rb_clickid — метка перехода VK Рекламы
  sent?: boolean; // уже отдана серверу после входа — повторно не шлём, но для шагов воронки храним
}

function readTag(): AdTag | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as AdTag) : null;
  } catch {
    return null;
  }
}

function postStep(tag: AdTag, step: 'visit' | 'photo'): void {
  // метка перехода VK нужна только после входа — в заходы её не шлём
  const { sent: _sent, clickId: _clickId, ...body } = tag;
  void fetch('/api/ad/visit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...body, step }),
    keepalive: true,
  }).catch(() => {});
}

/** При загрузке: на /go/<id> запомнить метку и отметить заход. */
export function captureAd(): void {
  try {
    const m = /^\/go\/([a-z0-9-]{2,48})\/?$/.exec(window.location.pathname);
    if (!m) return;
    const q = new URLSearchParams(window.location.search);
    const tag: AdTag = {
      trendId: m[1],
      source: q.get('utm_source'),
      medium: q.get('utm_medium'),
      campaign: q.get('utm_campaign'),
      content: q.get('utm_content'),
      clickId: q.get('rb_clickid'),
    };
    localStorage.setItem(KEY, JSON.stringify(tag));
    // перезагрузка страницы — не новый заход
    const seen = `dubl.adhit.${window.location.pathname}${window.location.search}`;
    if (MOCK || sessionStorage.getItem(seen)) return;
    sessionStorage.setItem(seen, '1');
    postStep(tag, 'visit');
  } catch {
    /* хранилище закрыто — без статистики */
  }
}

/** Шаг воронки на рекламной странице: нажал «Твоё фото». Раз за сессию на тренд. */
export function adStep(trendId: string): void {
  try {
    const tag = readTag();
    const seen = `dubl.adstep.photo.${trendId}`;
    if (!tag || tag.trendId !== trendId || MOCK || sessionStorage.getItem(seen)) return;
    sessionStorage.setItem(seen, '1');
    postStep(tag, 'photo');
  } catch {
    /* хранилище закрыто — без статистики */
  }
}

/** Человек вошёл: отдать метку серверу один раз. Первая метка у человека остаётся, повторная ничего не меняет. */
export async function sendAdTag(): Promise<void> {
  const tag = readTag();
  if (!tag || tag.sent || MOCK) return;
  try {
    const { sent: _sent, ...body } = tag;
    await api.adTag(body);
    localStorage.setItem(KEY, JSON.stringify({ ...tag, sent: true }));
  } catch {
    /* сеть — попробуем при следующем обновлении профиля */
  }
}
